import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{staticClass:"mt-4 mr-2",attrs:{"fluid":""}},[_c(VRow,[_c(VCard,{staticClass:"elevation-0 transparent"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }